// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import entityReducer from './generators/entityReducer'
import * as types from '../actions/action-types'
import * as entityTypes from './generators/entities'

export default entityReducer('workerDocumentTypes', {
  [entityTypes.ENTITIES_FETCH_BEGIN]: types.WORKER_DOCUMENT_TYPES_FETCH_BEGIN,
  [entityTypes.ENTITIES_FETCH_SUCCEEDED]: types.WORKER_DOCUMENT_TYPES_FETCH_SUCCEEDED,
  [entityTypes.ENTITIES_FETCH_FAILED]: types.WORKER_DOCUMENT_TYPES_FETCH_FAILED,
})
